import React from 'react'

import classNames from 'classnames'

import styles from './index.module.css'

export interface Props {
  /**
   * Card content
   */
  children: React.ReactNode

  /**
   * Additional CSS classes
   */
  className?: string

  /**
   * Unique card identifier
   */
  id: string

  [props: string]: any
}

const Wrapper: React.FC<Props> = ({
  children,
  className,
  id,
  ...props
}: Props): JSX.Element => (
  <div
    {...props}
    data-card-id={id}
    className={classNames(styles.card, className)}
  >
    {children}
  </div>
)

export default Wrapper
